import { render, staticRenderFns } from "./failed-invoice.vue?vue&type=template&id=c4aed68e&scoped=true"
import script from "./failed-invoice.vue?vue&type=script&lang=js"
export * from "./failed-invoice.vue?vue&type=script&lang=js"
import style0 from "./failed-invoice.vue?vue&type=style&index=0&id=c4aed68e&prod&scoped=true&lang=css"
import style1 from "./failed-invoice.vue?vue&type=style&index=1&id=c4aed68e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aed68e",
  null
  
)

export default component.exports